module.exports = __webpack_public_path__ + "img/2.5846f3e0.svg";